module.exports = __webpack_public_path__ + "img/arrow_back.a3f1b152.svg";